import React from 'react';
import {Badge, Col, Row} from 'reactstrap';
import Avatar from '../Avatar';

import RoleBadge from '../RoleBadge';

const UserCard = ({user}) => {
    const maxContentRestriction = user.allowedContentRestrictions?.length > 0
        ? Math.max(...user.allowedContentRestrictions)
        : null;

    return (
        <Row className="py-3 mx-0 my-3 border-start border-primary ps-3 h-auto text-uppercase bg-broken">
            <Col xs="auto">
                <Avatar
                    imageUrl={user.profilePic?.imageUrl}
                    name={`${user.firstName} ${user.lastName}`}
                    size={50}
                />
            </Col>
            <Col  className="d-flex justify-content-between align-items-center">
                <div>
                    <div className="name text-uppercase text-primary d-flex align-items-center ">
                        {`${user.firstName} ${user.lastName}`}
                    </div>

                    {user.parentOrganization && (
                        <span className="organization d-inline-block pe-3 text-white">
                        {user.parentOrganization?.name}
                    </span>
                    )}

                    <div className="d-flex gap-2 mt-2">
                        {user.hasPinCode && (
                            <Badge color="info" className="text-white">
                                <span className="fas fa-calculator me-1" />
                                PIN
                            </Badge>
                        )}
                        {user.twoFactorAuth?.isEnabled && (
                            <Badge color="success" className="text-white">
                                <span className="fas fa-shield-alt me-1" />
                                2FA
                            </Badge>
                        )}
                        {maxContentRestriction && (
                            <Badge color="secondary" className="text-white">
                                <span className="fas fa-film me-1" />
                                {maxContentRestriction}+
                            </Badge>
                        )}
                    </div>
                </div>
                <RoleBadge role={user.role}/>
            </Col>
        </Row>
    );
};

export default UserCard;
